import instance from './instance';

export const acceptMember = ({ memberSlug }) => instance.post('/workspaces/accept_member', { memberSlug });

export const captureDataViewed = ({ workspaceId, uuids }) =>
  instance.put(`/workspaces/${workspaceId}/capture_data_viewed`, { uuids });

export const transfer = ({ workspaceId, fromUserId, toUserId }) =>
  instance.put(`/workspaces/${workspaceId}/transfer?fromUserId=${fromUserId}&toUserId=${toUserId}`);

export const exportWorkspaceTxt = ({ workspaceId, startDate, endDate }) =>
  instance.get(`/workspaces/${workspaceId}/export_workspace_txt?startDate=${startDate}&endDate=${endDate}`);

export const exportWorkspaceCsv = ({ workspaceId, startDate, endDate }) =>
  instance.get(`/workspaces/${workspaceId}/export_workspace_csv?startDate=${startDate}&endDate=${endDate}`);

export const getTemplateSections = ({ workspaceId }) => instance.get(`/workspaces/${workspaceId}/template_sections`);

export const saveTemplate = ({
  workspaceId,
  name,
  isPublic,
  description,
  templateType,
  excludedItemUuids,
  sourcePage,
}) =>
  instance.post(`/workspaces/${workspaceId}/save_template`, {
    name,
    isPublic,
    description,
    templateType,
    excludedItemUuids,
    sourcePage,
  });

export const applyTemplate = ({ workspaceId, templateSlug, sourcePage, clientSyncToken }) =>
  instance.post(`/workspaces/${workspaceId}/apply_template`, { templateSlug, sourcePage, clientSyncToken });

export const cancelTemplateWizard = ({ workspaceId }) =>
  instance.delete(`/workspaces/${workspaceId}/cancel_template_wizard`);

export const bulkUpdateWorkspacesApi = data => instance.put('/workspaces/bulk_update_workspaces', data);

export const getCaptureData = ({ workspaceId, params }) =>
  instance.get(`/workspaces/${workspaceId}/capture_data`, { params });

export const getRecentUpdates = ({ workspaceId }) => instance.get(`/workspaces/${workspaceId}/recent_updates`);

export const bulkApplyTemplate = data => instance.post('/workspaces/bulk_apply_template', { ...data });

export const fetchAgendaAiSlackChannels = ({ workspaceId }) =>
  instance.get(`/workspaces/${workspaceId}/agenda_ai_slack_channels`);

export type FetchMeetingsAndTranscriptionsParams = {
  view?: 'day' | 'month';
  date?: string;
  include_snapshots?: boolean;
  include_summary?: boolean;
};

export type MeetingsAndTranscriptionsResponse = {
  view: 'day' | 'month';
  start_date: string;
  end_date: string;
  workspace_meetings: {
    data: any[];
    included?: any[];
  };
  meeting_transcriptions: {
    data: any[];
  };
};

export const fetchMeetingsAndTranscriptions = ({
  workspaceId,
  params,
}: {
  workspaceId: string;
  params: FetchMeetingsAndTranscriptionsParams;
}): Promise<import('axios').AxiosResponse<MeetingsAndTranscriptionsResponse>> =>
  instance.get(`/workspaces/${workspaceId}/meetings_and_transcriptions`, { params });
